import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import Location from '../../geom/Location';
import EdgeEndBuilder from './EdgeEndBuilder';
import NodeMap from '../../geomgraph/NodeMap';
import RelateNodeFactory from './RelateNodeFactory';
var RelateNodeGraph = /*#__PURE__*/function () {
  function RelateNodeGraph() {
    _classCallCheck(this, RelateNodeGraph);
    RelateNodeGraph.constructor_.apply(this, arguments);
  }
  _createClass(RelateNodeGraph, [{
    key: "insertEdgeEnds",
    value: function insertEdgeEnds(ee) {
      for (var i = ee.iterator(); i.hasNext();) {
        var e = i.next();
        this._nodes.add(e);
      }
    }
  }, {
    key: "getNodeIterator",
    value: function getNodeIterator() {
      return this._nodes.iterator();
    }
  }, {
    key: "copyNodesAndLabels",
    value: function copyNodesAndLabels(geomGraph, argIndex) {
      for (var nodeIt = geomGraph.getNodeIterator(); nodeIt.hasNext();) {
        var graphNode = nodeIt.next();
        var newNode = this._nodes.addNode(graphNode.getCoordinate());
        newNode.setLabel(argIndex, graphNode.getLabel().getLocation(argIndex));
      }
    }
  }, {
    key: "build",
    value: function build(geomGraph) {
      this.computeIntersectionNodes(geomGraph, 0);
      this.copyNodesAndLabels(geomGraph, 0);
      var eeBuilder = new EdgeEndBuilder();
      var eeList = eeBuilder.computeEdgeEnds(geomGraph.getEdgeIterator());
      this.insertEdgeEnds(eeList);
    }
  }, {
    key: "computeIntersectionNodes",
    value: function computeIntersectionNodes(geomGraph, argIndex) {
      for (var edgeIt = geomGraph.getEdgeIterator(); edgeIt.hasNext();) {
        var e = edgeIt.next();
        var eLoc = e.getLabel().getLocation(argIndex);
        for (var eiIt = e.getEdgeIntersectionList().iterator(); eiIt.hasNext();) {
          var ei = eiIt.next();
          var n = this._nodes.addNode(ei.coord);
          if (eLoc === Location.BOUNDARY) n.setLabelBoundary(argIndex);else if (n.getLabel().isNull(argIndex)) n.setLabel(argIndex, Location.INTERIOR);
        }
      }
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._nodes = new NodeMap(new RelateNodeFactory());
    }
  }]);
  return RelateNodeGraph;
}();
export { RelateNodeGraph as default };